import React, { useContext, useEffect, useState } from 'react';
import useCollapse from 'react-collapsed';
import './TabNotificationCollapse.scss';
import { Tooltip, Typography } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Appeal } from '../../model/Appeal';
import { formatDate, formatHtmlString } from '../../utils/formatter';
import TabNotificationRow from '../TabNotificationRow/TabNotificationRow';
import TabNotificationRoleRow from '../TabNotificationRow/TabNotificationRoleRow';
import AppealAnswer from '../AppealAnswer/AppealAnswer';
import { useAppeal } from '../../context/appeal/AppealContext';
import parse from 'html-react-parser';
import { Context } from '../../index';
import Constants from '../../constants/constants';

interface TabNotificationCollapseProps {
  appeal: Appeal;
  onlyUserStatus: boolean;
  handleAppealRemove: (appealId: number) => void;
}

const TabNotificationCollapse = (
  props: TabNotificationCollapseProps
): JSX.Element => {
  const [appeal, setAppeal] = useState<Appeal>(props.appeal);
  const { refresh, removeRefreshed } = useAppeal();
  const [renderChildren, setRenderChildren] = useState(false);
  const { store } = useContext(Context);

  const { getToggleProps, getCollapseProps, isExpanded } = useCollapse({
    defaultExpanded: false,
    onExpandStart() {
      setRenderChildren(true);
    },
    onCollapseEnd() {
      setRenderChildren(false);
    },
  });

  useEffect(() => {
    if (
      !props.onlyUserStatus &&
      refresh.length > 0 &&
      refresh.includes(props.appeal.id)
    ) {
      store.getAppealsListByRole(props.appeal.id).then((resp) => {
        if (resp && resp[0]) {
          setAppeal(resp[0]);
          removeRefreshed(resp[0].id);
        }
      });
    }
  }, [refresh]);

  return (
    <div
      className={`tabNotificationCollapse ${isExpanded ? 'openContent' : ''}`}
    >
      <div className="tabNotificationCollapse__header">
        <div className="tabNotificationCollapse__id">
          <Title level={4}>{appeal.id}</Title>
        </div>
        <div className="tabNotificationCollapse__message-title">
          {formatHtmlString(appeal.description)}
        </div>
        <div className="tabNotificationCollapse__status">
          {props.onlyUserStatus ? (
            <>
              <div
                className={`statusRound statusRound-${appeal.statusUser.code}`}
              />
              <Typography.Paragraph>
                {appeal.statusUser.name}
              </Typography.Paragraph>
            </>
          ) : (
            <>
              <div
                className={`statusRound statusRound-${appeal.status.code}`}
              />
              <Typography.Paragraph>{appeal.status.name}</Typography.Paragraph>
            </>
          )}
        </div>
        <div className="tabNotificationCollapse__date">
          <Typography.Paragraph>
            {formatDate(appeal.createdAt)}
          </Typography.Paragraph>
        </div>
        <div className="tabNotificationCollapse__info">
          <button {...getToggleProps()}>
            {isExpanded ? 'Свернуть' : 'Подробнее'}
          </button>
          <div {...getToggleProps({})} className={isExpanded ? 'active' : ''} />
        </div>
      </div>
      <div
        className="tabNotificationCollapse__content"
        {...getCollapseProps({})}
      >
        {renderChildren && (
          <div className="tabNotificationCollapse__box">
            <div className="tabNotificationCollapse__title">
              Сообщение гражданина
              {appeal.isAccepted && (
                <Tooltip title={Constants.acceptedText} placement="right">
                  <div className="tabNotificationCollapse__icon" />
                </Tooltip>
              )}
            </div>
            <TabNotificationRow appeal={appeal} />
            {store.isAdmin && !props.onlyUserStatus ? (
              <>
                {appeal.moderatorComment && (
                  <div className="tabNotificationRow">
                    <Typography.Paragraph className="tabNotificationRow__title">
                      Комментарий модератора:
                    </Typography.Paragraph>
                    <div className="tabNotificationRow__text">
                      {parse(appeal.moderatorComment)}
                    </div>
                  </div>
                )}
                <TabNotificationRoleRow
                  appeal={appeal}
                  handleAppealRemove={props.handleAppealRemove}
                />
              </>
            ) : (
              <AppealAnswer appealId={appeal.id} appeal={appeal} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TabNotificationCollapse;
